import { auth, subjectGrade } from "../puglins/Utils/models";
import i18next from "i18next";
import notistack from "../puglins/notistack";
import noNetworkAction from "../puglins/Utils/errorManage";


// ⏳ Renvoie la promesse de la lecture du compte (attendue par App.js au premier chargement, tour 34)
export const getAuthUser = (history) => {
  return (dispatch) => {
    return auth
      .getAuthUserData()
      .then((res) => {
        dispatch(getAuthUserSuccess(res?.data));
      })
      .catch((error) => {
        error?.message==='Network Error'&&noNetworkAction(history)
        dispatch(getAuthUserFailure(error));
      });
  };
};
export const setAccess = (data) => {
  return {
    type: "SET_ACCESS",
    payload: data,
  };
};
export const isLogin = (data) => {
  return {
    type: "SET_ISLOGIN",
    payload: data,
  };
};
export const getNotificationData = (history) => {
  return (dispatch) => {
    auth
      .getNotification()
      .then((res) => {
        dispatch({ type: "SET_NOTIFICATION", payload: res } || []);
      })
      .catch((error) => {
        error?.message==='Network Error'&&noNetworkAction(history)
        // Traduit ici : notistack affiche le texte tel quel (avant : la clé brute « error_fetch_notifications », tour 65)
        notistack.error(i18next.t("error_fetch_notifications"));
      });
  };
};
export const getLanguages = (history) => {
  return (dispatch) => {
    subjectGrade
      .getLangauge()
      .then((response) => {
        dispatch(getLanguageSuccess(response?.data));
      })
      .catch((error) => {
        error?.message === "Network Error" && noNetworkAction(history);
        dispatch(getLanguageFailure(error));
        console.error("Error while Getting Language", error);
      });
  };
};
// ------To get grade Intially and store it in redux
export const getGrade = (history) => {
  return (dispatch) => {
    subjectGrade
      .getGrade()
      .then((res) => {
        dispatch(getGradeSuccess(res?.data));
      })
      .catch((err) => {
        err?.message === "Network Error" && noNetworkAction(history);
        dispatch(getGradeFailure(err));
        console.error("Error while fetching grades", err);
      });
  };
};
// ------To get subject Intially and store it in redux
export const getSubjects = (history) => {
  return (dispatch) => {
    subjectGrade
      .getSubjects()
      .then((res) => {
        dispatch(getSubjectSuccess(res?.data));
      })
      .catch((err) => {
        err?.message === "Network Error" && noNetworkAction(history);
        dispatch(getSubjectFailure(err));
        console.error("Error while fetching subject", err);
      });
  };
};
export const getAuthUserSuccess = (userData) => {
  return {
    type: "GETAUTHUSER_SUCCESS",
    payload: userData,
  };
};

export const getAuthUserFailure = (error) => {
  return {
    type: "GETAUTHUSER_FAILURE",
    payload: error,
  };
};

export const getLanguageSuccess = (data) => {
  return {
    type: "GETLANGUAGE_SUCCESS",
    payload: data,
  };
};

export const getLanguageFailure = (error) => {
  return {
    type: "GETLANGUAGE_FAILURE",
    payload: error,
  };
};

export const getGradeSuccess = (data) => {
  return {
    type: "GETGRADE_SUCCESS",
    payload: data,
  };
};

export const getGradeFailure = (error) => {
  return {
    type: "GETGRADE_FAILURE",
    payload: error,
  };
};
export const getSubjectSuccess = (data) => {
  return {
    type: "GETSUBJECT_SUCCESS",
    payload: data,
  };
};

export const getSubjectFailure = (error) => {
  return {
    type: "GETSUBJECT_FAILURE",
    payload: error,
  };
};
// 🔌 Connexion temps réel d'un compte connecté. socket.io est chargé à part (tour 50) : un visiteur ne
// télécharge plus son code (environ 40 Ko), qui ne lui sert à rien
export const openSocket = () =>
  import("socket.io-client").then(({ io }) => {
    const isLocal = window.location.hostname === "localhost";
    return io(process.env.REACT_APP_SOCKET_IO_URL, {
      reconnection: true,
      path: "/socket.io",
      transports: ["polling", "websocket"], // Ajoute 'polling' ici
      secure: !isLocal,
    });
  });
export const setSocket = (socket) => ({ type: "GET_SOCKET", payload: socket });
// Plus de connexion temps réel (compte déconnecté, App.js)
export const clearSocket = () => ({ type: "GET_SOCKET", payload: null });